export default __webpack_public_path__ + "7106c70387b9245c76a186fc128a10bd.woff";